module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qnerv14-8bcba31070bc144faa8d0172b3e06f38.jpg";